export default {
  "menu.welcome": "欢迎",
  "menu.more-blocks": "更多区块",
  "menu.home": "首页",
  "menu.create": "创建",
  "menu.admin": "管理页",
  "menu.admin.sub-page": "二级管理页",
  "menu.login": "登录",
  "menu.register": "注册",
  "menu.register-result": "注册结果",
  "menu.dashboard": "Dashboard",
  "menu.dashboard.analysis": "分析页",
  "menu.dashboard.monitor": "监控页",
  "menu.dashboard.workplace": "工作台",
  "menu.exception.403": "403",
  "menu.exception.404": "404",
  "menu.exception.500": "500",
  "menu.form": "表单页",
  "menu.form.basic-form": "基础表单",
  "menu.form.step-form": "分步表单",
  "menu.form.step-form.info": "分步表单（填写转账信息）",
  "menu.form.step-form.confirm": "分步表单（确认转账信息）",
  "menu.form.step-form.result": "分步表单（完成）",
  "menu.form.advanced-form": "高级表单",
  "menu.list": "列表页",
  "menu.list.table-list": "查询表格",
  "menu.list.basic-list": "标准列表",
  "menu.list.card-list": "卡片列表",
  "menu.list.search-list": "搜索列表",
  "menu.list.search-list.articles": "搜索列表（文章）",
  "menu.list.search-list.projects": "搜索列表（项目）",
  "menu.list.search-list.applications": "搜索列表（应用）",
  "menu.profile": "详情页",
  "menu.profile.basic": "基础详情页",
  "menu.profile.advanced": "高级详情页",
  "menu.result": "结果页",
  "menu.result.success": "成功页",
  "menu.result.fail": "失败页",
  "menu.exception": "异常页",
  "menu.exception.not-permission": "403",
  "menu.exception.not-find": "404",
  "menu.exception.server-error": "500",
  "menu.exception.trigger": "触发错误",
  "menu.account": "个人页",
  "menu.account.center": "个人中心",
  "menu.account.settings": "个人设置",
  "menu.account.trigger": "触发报错",
  "menu.account.logout": "退出登录",
  "menu.editor": "图形编辑器",
  "menu.editor.flow": "流程编辑器",
  "menu.editor.mind": "脑图编辑器",
  "menu.editor.koni": "拓扑编辑器",
  "menu.goods": "商品管理",
  "menu.goods.list": "商品列表",
  "menu.goods.create": "商品发布",
  "menu.goods.detail": "商品编辑",
  "menu.goods.material": "商品素材",
  "menu.goods.grow": "商品成长",
  "menu.goods.growDetail": "商品成长详情",
  "menu.goods.missingWarning": "商品缺图预警",
  "menu.auth": "授权",
  "menu.order": "订单管理",
  "menu.order.sheet": "订货单",
  "menu.order.sheet.unifiedCreate": "订货单",
  "menu.order.sheet.create": "开单",
  "menu.order.sheet.outOfStock": "断货",
  "menu.order.sales": "订单",
  "menu.order.sales.salesDetail": "订单详情",
  "menu.order.sales.unifiedDetail": "订单详情",
  "menu.order.owedGoods": "欠货明细",
  "menu.order.create": "开单",
  "menu.order.outOfStock": "断货",
  "menu.order.unifiedCreate": "开单",
  "menu.order.feeActivity": "活动费清单",
  "menu.order.feeActivityDetail": "活动费清单详情",
  "menu.order.shippingOrder": "发货单",
  "menu.live": "直播",
  "menu.live.shopLive": "店铺直播",
  "menu.live.liveData": "直播数据",
  "menu.live.liveDataDetail": "直播数据详情",
  "menu.data": "数据中心",
  "menu.data.overview": "经营概览",
  "menu.data.trade": "交易数据",
  "menu.data.goods": "商品数据",
  "menu.data.goods.goodsOverview": "商品概况",
  "menu.data.goods.goodsDetail": "商品明细",
  "menu.data.flow": "流量数据",
  "menu.data.performance": "履约数据",
  "menu.data.afterSale": "售后数据",
  "menu.data.afterSale.detail": "退换货商品明细",
  "menu.shop": "店铺管理",
  "menu.shop.information": "店铺信息",
  "menu.shop.subAccount": "子账号管理",
  "menu.shop.claims": "赔付管理",
  "menu.shop.claimsDetail": "赔付详情",
  "menu.shop.dataExport": "店铺数据导出",
  "menu.shop.billExport": "店铺账单导出",
  "menu.shop.createPosition": "新增岗位",
  "menu.shop.editPosition": "编辑权限",
  "menu.shop.viewPosition": "查看权限",
  "menu.shop.accountPermission": "账号权限",
  "menu.shop.grown": "商家成长中心",
  "menu.personal": "个人信息",
  "menu.personal.account": "账号管理",
  "menu.market": "营销管理",
  "menu.market.decorate": "店铺装修",
  "menu.market.decorate.mainNew": "主推新款",
  "menu.market.decorate.hotSell": "店铺爆款",
  "menu.market.decorate.treasure": "镇店之宝",
  "menu.market.decorate.goodsTop": "商品置顶",
  "menu.market.plaza": "活动广场",
  "menu.market.packet": "红包",
  "menu.market.packet.create": "创建红包",
  "menu.market.discount": "满减",
  "menu.market.discount.create": "创建满减",
  "menu.market.specialPrice": "特价",
  "menu.market.specialPrice.create": "创建特价",
  "menu.market.flashSale": "秒杀",
  "menu.market.flashSale.create": "创建秒杀",
  "menu.market.flashSale.detail": "秒杀详情",
  "menu.preStore": "前置仓管理",
  "menu.preStore.plan": "计划",
  "menu.preStore.plan.create": "创建计划",
  "menu.preStore.plan.detail": "计划详情",
  "menu.preStore.invitation": "邀约池",
  "menu.preStore.invitation.create": "邀约开单",
  "menu.preStore.stock": "库存",
  "menu.preStore.stockMovement": "出入库日志",
  "menu.preStore.refund": "退供",
  "menu.preStore.refund.create": "创建退供申请",
  "menu.preStore.refund.detail": "创建退供详情",
  "menu.preStore.report": "报表",
  "menu.preStore.report.detail": "报表详情",
  "menu.preStore.report.balanceDetail": "结余明细",
  "menu.preStore.report.planDetail": "计划商品明细",
  "menu.preStore.report.noDataDetail": "无数据商品明细",
  "menu.preStore.report.stockOutDetail": "发货商品明细",
  "menu.preStore.report.returnDetail": "退供商品明细",
  "menu.preStore.report.billDetail": "账单明细",
  "menu.capital": "资金管理",
  "menu.capital.account": "资金账户",
  "menu.capital.bill": "账单",
  "menu.capital.billDetail": "账单详情",
  "menu.capital.bankCard": "银行卡管理",
  "menu.capital.bankCard.create": "添加银行卡",
  "menu.capital.bankCard.sign": "鉴权",
  "menu.capital.withdraw": "提现",
  "menu.capital.addMoney": "提现",
  "menu.capital.contractInfoChange": "更改合同签署信息",
  "menu.member": "用户管理",
  "menu.member.portrait": "用户画像",
  "menu.member.segmentation": "人群管理",
  "menu.member.segmentation.create": "创建人群",
  "menu.member.segmentation.edit": "编辑人群",
  "menu.member.message": "短信营销",
  "menu.member.message.purchase": "短信购买",
  "menu.member.message.purchaseRecord": "购买记录",
  "menu.member.message.bill": "短信账单",
  "menu.member.message.planCreate": "创建短信计划",
  "menu.member.message.planEdit": "编辑短信计划",
  "menu.hangtagCareLabelPrint": "吊牌/洗水唛打印",
};
